import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=264aba5e"
import script from "./CircularLoader.vue?vue&type=script&lang=js"
export * from "./CircularLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports